import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MemberDto } from '@careapp-group/ng-sdk-v2-new';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { auth } from '../../../store/auth/auth.selectors';
import { Conversations } from '../../../store/conversations/conversations.actions';
import { conversationMembers } from '../../../store/conversations/conversations.selectors';

export interface ParticipantSelectDialogData {
  // IDs of users that will be pre-selected, but can be toggled off.
  initialSelectedIds: string[];
  // IDs of users that cannot be toggled.
  disabledIds: string[];
}

@Component({
  selector: 'ca-conversation-participant-select-dialog',
  styleUrls: ['./conversation-participant-select-dialog.component.scss'],
  templateUrl: './conversation-participant-select-dialog.component.html',
})
export class ConversationParticipantSelectDialogComponent {
  _search = '';
  public allMembers$: Observable<MemberDto[]>;
  public currentUser$: Observable<MemberDto>;
  public selectedIds: string[] = [];
  public disabledIds: string[] = [];

  constructor(
    public store: Store<any>,
    @Inject(MAT_DIALOG_DATA) public data: ParticipantSelectDialogData
  ) {}

  ngOnInit() {
    this.selectedIds = [...(this.data.initialSelectedIds ?? [])];
    this.disabledIds = [...(this.data.disabledIds ?? [])];
    this.store.dispatch(Conversations.requestConversationMembers());
    this.allMembers$ = this.store.select(conversationMembers);
    this.currentUser$ = this.store.select(auth.getLoggedInUser);
  }

  toggle(member: MemberDto) {
    const isSelected = !!this.selectedIds.find((id) => id === member.id);

    this.selectedIds = isSelected
      ? this.selectedIds.filter((id) => id !== member.id)
      : [...this.selectedIds, member.id];
  }

  set search(value: string) {
    this._search = value;
  }
  get search() {
    return this._search;
  }

  get selectedIdFilter() {
    return (item: MemberDto, index) => item && this.selectedIds.includes(item.id);
  }
}
